import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const ReloadIcon = ({ viewBox, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 24 24'}>
    <path
      d="M20.7748 11.2028L17.9824 13.925C17.8205 14.0806 17.6182 14.1583 17.3956 14.1583C17.173 14.1583 16.9707 14.0806 16.8088 13.925L14.0163 11.2028C13.7128 10.8917 13.7128 10.4056 14.0163 10.0944C14.3401 9.80278 14.846 9.80278 15.1697 10.0944L16.7278 11.6111C16.5255 8.79167 14.1175 6.55555 11.1834 6.55555C8.10771 6.55555 5.6188 9.00555 5.6188 12C5.6188 14.9944 8.10771 17.4444 11.1834 17.4444C12.3166 17.4444 13.4093 17.1139 14.3199 16.4917C14.6841 16.2389 15.19 16.3361 15.453 16.6861C15.7161 17.0361 15.6149 17.5222 15.2507 17.775C14.0568 18.5722 12.6403 19 11.1834 19C7.21737 19 4 15.8694 4 12C4 8.13055 7.21737 5 11.1834 5C14.9067 5 17.9824 7.78056 18.3264 11.3389L19.6012 10.0944C19.9249 9.78333 20.4308 9.78333 20.7546 10.0944C21.0784 10.4056 21.0784 10.8917 20.7748 11.2028Z"
      fill="#FF8000"
    />
  </BaseIcon>
);

export default ReloadIcon;
